import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Card, Button, Modal, CloseButton, Spinner,Table, Row, Col } from 'react-bootstrap';
import useFetchWithCancellation from "../../../../customhooks/useFetchWithCancellation";
import { UpdtInvoiceContAction } from "../../../../Reducer/UpdatedInvoiceContentReducer";
import { ErrorBoundary } from 'react-error-boundary';
import { InvoiceMeetingAction } from "../../../../Reducer/InvoiceMeetingsReducer";
import PCPInvoiceMeetingForm from "./PCPInvoiceMeetingForm";
import Icon from "../../../controls/Icons/Icon";
import ErrorHandler from "../../../controls/ErrorHandler";
import { dateDisplayFormater, getDateSaveFormat } from "../../../../Utils";
import Invoice from "../../Invoice/Invoice";


const PCPInvoiceMeeting = ({ afterSelect, ClientId, InvoiceId, refresh, isfromEdit, isViewOnly }) => {
    const [searchParams] = useSearchParams();
   // const[isViewScreen] = searchParams.get("view");
    const [isViewScreen] = useState(isViewOnly);
    const { fetchData } = useFetchWithCancellation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { Id } = useParams();
    const state = useSelector(state => state);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState({
    });
    const [invoiceMeetings, setInvoiceMeetings] = useState([]);
    const [manualMeetingId, setManualMeetingId] = useState(0);
    
    const [totalAmount, setTotalAmount] = useState(0);
    const [isMeetingupdated, setisMeetingupdated] = useState(false);

    
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);

    //useEffect(() => {
    //    if (isViewScreen == null) {
    //        setisViewScreen(false);
    //    }
    //}, []);


    const handleAfter = (res) => {
        setManualMeetingId(manualMeetingId + 1);
        let resObj = {
            ...res, Id: manualMeetingId + 1
        };
        let currInvCnt = ({
            Id: manualMeetingId + 1,
            Description: resObj.Description,
            Rate: resObj.Rate,
            Amount: resObj.Amount,
            TotalHours: resObj.TotalHours,
            isManual: resObj.isManual,
            isDisabled: true,
            isRateDisabled: true,
            MeetingDate: getDateSaveFormat(resObj.MeetingDate),
            isUsedInInvoice: false,
        });
        dispatch({ type: InvoiceMeetingAction.AddInvoiceMeeting, payload: currInvCnt });
        setShowModal(false);
     };
    const parseLocalDate = (dateString) => {
        const [y, m, d] = dateString.split("-");
        return new Date(y, m - 1, d);
    };
    useEffect(() => {
      //  if (invoiceMeetings.length == 0) {
        dispatch({ type: InvoiceMeetingAction.RemoveAllInvoiceMeeting });
        dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
        setInvoiceMeetings([]);
       // setisMeetingupdated(!isMeetingupdated);
        setLoading(true);
        let ClntId = 0;
        let InvId = 0;
        if (ClientId > 0) ClntId = ClientId;
        if (InvoiceId > 0) InvId = InvoiceId;
      //  if (!ClientId) ClientId = Id;
        // if (!InvoiceId) InvoiceId = 0;
        // if (isViewScreen == null) isViewScreen = false;
        let isViewEnabled = false;
        if (isViewScreen === 'true') {
            isViewEnabled = true;
        }
        if (searchParams.get("view")  !=null && searchParams.get("view") == 'true') {
            isViewEnabled = true;
        }
        
        
        let Url = "/Invoice/GetInvoiceMeetings?clientId=" + ClntId + "&InvoiceId=" + InvId + "&isViewScreen=" + isViewEnabled;
        //fetchData(state.projectdetail.API + "/Invoice/GetInvoiceMeetings?clientId=" + ClientId + "&InvoiceId=" + InvoiceId), {
        //    method: "Get"
        //}).then(response => response.json()).then((res) => {
        fetchData(state.projectdetail.API + Url, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res && res.invoiceMeeting && res.invoiceMeeting.length > 0) {
                       
                        for (let i = 0; i < res.invoiceMeeting.length; i++) {
                            
                            let currInvitem = res.invoiceMeeting[i];
                            //const meetdate = parseLocalDate(currInvitem.MeetingDate);
                            //meetdate.setDate(meetdate.getDate() + 1);
                          
                            const formattedDate = currInvitem.MeetingDate.split("T")[0];

                            if (currInvitem.Rate === '') currInvitem.Rate = 100;
                            let currInvCnt = ({
                                Id: currInvitem.MeetingId,
                                Description: currInvitem.Description,
                                Rate: currInvitem.Rate,
                                Amount: currInvitem.Amount,
                                TotalHours: currInvitem.TotalHours,
                                isManual: currInvitem.isManual,
                                MeetingDate: formattedDate,
                                isDisabled: true,
                                isRateDisabled: true,
                                isAddedtoInvoice: currInvitem.isAddedtoInvoice,
                                isUsedInInvoice: currInvitem.isUsedInInvoice,
                            });
                            if (res.totalSpentAmount > 0 && currInvitem.isAddedtoInvoice) {
                                dispatch({ type: InvoiceMeetingAction.AddInvoiceMeeting, payload: currInvCnt });
                                if (!currInvitem.isUsedInInvoice) {
                                    dispatch({ type: UpdtInvoiceContAction.AddUpdtInvoiceContent, payload: currInvCnt });
                                }
                            } else {
                                dispatch({ type: InvoiceMeetingAction.AddInvoiceMeeting, payload: currInvCnt });
                            }

                        }
                        //setisMeetingupdated(!isMeetingupdated);
                        setInvoiceMeetings(state.invMeetings);
                        setisMeetingupdated(!isMeetingupdated);
                        if (res.totalSpentAmount > 0) {
                            setTotalAmount(res.totalSpentAmount);
                        }
                        
                    }
                }).catch((err) => {
                    if (err && err.name === 'AbortError') return;
                    window.HandleError("PCPMeeting.js ==> GetInvoiceMeetings", null, null, err);
                    window.alert(state.projectdetail.ErrorMessage);
                }).finally(() => {
                    setLoading(false);
                });
      //  }

    }, []);

    useEffect(() => {
        if (state.invMeetings && state.invMeetings[0] !== undefined && state.invMeetings.length > 0) {
            setInvoiceMeetings(state.invMeetings);
        }
    }, [isMeetingupdated, invoiceMeetings])


    useEffect(() => {
        if (totalAmount > 0) {
            if (state.invMeetings && state.invMeetings[0] !== undefined && state.invMeetings.length > 0) {
                setInvoiceMeetings(state.invMeetings);
            }
            afterSelect(totalAmount);
        }
    }, [totalAmount]);

    const handleChkBox = (e, rowData, disabled) => {
        let isChecked = e.target.checked;
        if (!disabled) {
            if (e.target.checked) {
                const meetdateTime = rowData.MeetingDate + "T00:00:00";
                let currInvCnt = ({
                    Id: rowData.Id,
                    Description: rowData.Description,
                    Rate: 100,
                    Amount: parseFloat(rowData.TotalHours)*100,
                    TotalHours: rowData.TotalHours,
                    isManual: false,
                    MeetingDate: meetdateTime,
                    MeetingId: rowData.Id,
                    isDisabled: true,
                    isRateDisabled: true,
                });

                dispatch({ type: UpdtInvoiceContAction.AddUpdtInvoiceContent, payload: currInvCnt });

            } else {
                dispatch({ type: UpdtInvoiceContAction.RemoveUpdtInvoiceContent, payload: rowData.Id });
            }
        rowData.isAddedtoInvoice = e.target.checked;
        afterSelect(e.target.checked);
    }
    };
  

    return (
        <ErrorBoundary FallbackComponent={ErrorHandler}>
            <Row>
                <Col md={9}>
                    <h5 className="d-inline-block">Meetings to be invoiced:</h5>
                </Col>
                {/*<Col>*/}
                {/*    <Button type="button" onClick={HandleAddMeeting} className="me-2" variant="primary">Add Meeting</Button>*/}
                {/*</Col>*/}
            </Row>
            
            <Card className="withborder" style={{background:'white'}} >
                <Card.Body>
                    {/*{loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}*/}
                    {/*<DataGrid url={state.projectdetail.API + "/pcp/grid?clientId=" + id} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />*/}
                    {/*PCP meetings code starts here*/}
                    <Row>
                        <Col>
                            <Table responsive className="table">
                                <thead>
                                    <tr>
                                        <th md={1}>Sl.No</th>
                                        <th md={1}></th>
                                        <th md={1}>Date</th>
                                        <th md={1}>Total Hours</th>
                                        <th md={1}>Description</th>
                                      
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoiceMeetings && invoiceMeetings.length > 0 && invoiceMeetings.map((rowData, rindex) => {
                                        return (
                                            !rowData.isManual && 
                                            <tr key={rindex + 1} >
                                                <td style={{ width: '5%' }}>
                                                    {rindex + 1}
                                                </td>



                                                {InvoiceId === 0 && rowData.isUsedInInvoice &&
                                                    (
                                                        <td style={{ width: '5%' }}></td>
                                                    )
                                                }
                                                {InvoiceId === 0 && !rowData.isUsedInInvoice &&
                                                    (
                                                        <td style={{ width: '5%' }}>
                                                            <input type="checkbox" id={"chk_" + rowData.Id}
                                                                className="btn-xs me-2 mb-2 p-0"
                                                                // checked={rowData.isAddedtoInvoice}
                                                                //  disabled={rowData.isAddedtoInvoice}
                                                                onClick={(e) => {
                                                                    handleChkBox(e, rowData, false);
                                                                }
                                                                }
                                                            />

                                                        </td>
                                                    )
                                                }
                                                {InvoiceId > 0 && !isViewScreen && !rowData.isUsedInInvoice &&
                                                    <td>
                                                        <input type="checkbox" id={"chk_" + rowData.Id}
                                                            className="btn-xs me-2 mb-2 p-0"
                                                            checked={rowData.isAddedtoInvoice}
                                                            //  disabled={rowData.isAddedtoInvoice}
                                                            onClick={(e) => {
                                                                handleChkBox(e, rowData, false);
                                                            }
                                                            }
                                                        />
                                                    </td>
                                                }

                                                {InvoiceId > 0 && !isViewScreen && rowData.isUsedInInvoice &&
                                                    <td>
                                                        {/*<input type="checkbox" id={"chk_" + rowData.Id}*/}
                                                        {/*    className="btn-xs me-2 mb-2 p-0"*/}
                                                        {/*    checked={rowData.isAddedtoInvoice}*/}
                                                        {/*    //  disabled={rowData.isAddedtoInvoice}*/}
                                                        {/*    onClick={(e) => {*/}
                                                        {/*        handleChkBox(e, rowData, false);*/}
                                                        {/*    }*/}
                                                        {/*    }*/}
                                                        {/*/>*/}
                                                    </td>
                                                }

                                                {InvoiceId > 0 && isViewScreen && rowData.isAddedtoInvoice && (rowData.id == InvoiceId) && (

                                                    <td>

                                                        <input type="checkbox" id={"chk_" + rowData.Id}
                                                            className="btn-xs me-2 mb-2 p-0"
                                                            checked={rowData.isAddedtoInvoice}
                                                            disabled={rowData.isAddedtoInvoice}
                                                            onClick={(e) => {
                                                                handleChkBox(e, rowData, true);
                                                            }
                                                            }
                                                        />
                                                    </td>
                                                )}

                                                {InvoiceId > 0 && isViewScreen && rowData.isUsedInInvoice && (
                                                    <td>
                                                        {/*<input type="checkbox" id={"chk_" + rowData.Id}*/}
                                                        {/*    className="btn-xs me-2 mb-2 p-0"*/}
                                                        {/*    checked={rowData.isAddedtoInvoice}*/}
                                                        {/*    disabled={rowData.isAddedtoInvoice}*/}
                                                        {/*    onClick={(e) => {*/}
                                                        {/*        handleChkBox(e, rowData, true);*/}
                                                        {/*    }*/}
                                                        {/*    }*/}
                                                        {/*/>*/}
                                                    </td>
                                                )}

                                                <td style={{ width: '20%' }}>
                                                    {rowData.MeetingDate}
                                                </td>
                                                <td style={{ width: '10%' }}>
                                                    {rowData.TotalHours}
                                                </td>
                                                <td style={{ width: '50%' }}>
                                                    {rowData.Description}
                                                </td>

                                            </tr>
                                        )

                                        
                                    }
                                    )
                                    }

                                    <tr>

                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                     {/*PCP meetings code ends here*/}
                </Card.Body>
            </Card>
            <Modal show={showModal} onHide={handleClose} size="lg" backdrop="static">
                <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                    <h4>{inputValue.Id ? "Edit " : "Add "} Meetings </h4>
                    <CloseButton onClick={handleClose} className="btn-close" />
                </Modal.Header>
                <Modal.Body>
                    <PCPInvoiceMeetingForm afterSave={handleAfter} _inputValue={inputValue} onCancel={handleClose} />
                </Modal.Body>
            </Modal>
           
        </ErrorBoundary>
    );
}
export default (PCPInvoiceMeeting);
